/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetCurrentMenuItemForUpdateDocument = gql`
    query GetCurrentMenuItemForUpdate($dishId: Int, $companyId: Int!, $locale: String, $isDeletedSupplements: Boolean) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      id
      menuItems(id: $dishId, locale: $locale) {
        items {
          id
          name(locale: $locale)
          nameOrigin
          types {
            id
            name
            slug
          }
          deleted
          favicon
          types {
            id
            name
            slug
          }
          categories {
            id
            name(locale: $locale)
            nameOrigin
            comment(locale: $locale)
            descriptionOrigin
            favicon {
              id
              isDefault
              path
            }
            deleted
            parentCategory {
              id
              name(locale: $locale)
              nameOrigin
              comment(locale: $locale)
              descriptionOrigin
              favicon {
                id
                isDefault
                path
              }
              deleted
              childCategories {
                id
                name(locale: $locale)
                nameOrigin
                comment(locale: $locale)
                descriptionOrigin
                favicon {
                  id
                  isDefault
                  path
                }
                deleted
              }
            }
            company {
              id
            }
          }
          description(locale: $locale)
          descriptionOrigin
          composition(locale: $locale)
          compositionOrigin
          unit {
            id
            name
          }
          portions {
            id
            name(locale: $locale)
            nameOrigin
            volume
            price
          }
          cookingTime
          isLongCookingTime
          markers {
            id
            name
            slug
          }
          allergens {
            id
            name
            slug
          }
          supplements(isDeleted: $isDeletedSupplements) {
            id
            groupName(locale: $locale)
            groupNameOrigin
          }
          favicon
          deleted
        }
      }
    }
  }
}
    `;

/**
 * __useGetCurrentMenuItemForUpdateQuery__
 *
 * To run a query within a React component, call `useGetCurrentMenuItemForUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentMenuItemForUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentMenuItemForUpdateQuery({
 *   variables: {
 *      dishId: // value for 'dishId'
 *      companyId: // value for 'companyId'
 *      locale: // value for 'locale'
 *      isDeletedSupplements: // value for 'isDeletedSupplements'
 *   },
 * });
 */
export function useGetCurrentMenuItemForUpdateQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentMenuItemForUpdateQuery, GetCurrentMenuItemForUpdateQueryVariables> & ({ variables: GetCurrentMenuItemForUpdateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentMenuItemForUpdateQuery, GetCurrentMenuItemForUpdateQueryVariables>(GetCurrentMenuItemForUpdateDocument, options);
      }
export function useGetCurrentMenuItemForUpdateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentMenuItemForUpdateQuery, GetCurrentMenuItemForUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentMenuItemForUpdateQuery, GetCurrentMenuItemForUpdateQueryVariables>(GetCurrentMenuItemForUpdateDocument, options);
        }
export function useGetCurrentMenuItemForUpdateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentMenuItemForUpdateQuery, GetCurrentMenuItemForUpdateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentMenuItemForUpdateQuery, GetCurrentMenuItemForUpdateQueryVariables>(GetCurrentMenuItemForUpdateDocument, options);
        }
export type GetCurrentMenuItemForUpdateQueryHookResult = ReturnType<typeof useGetCurrentMenuItemForUpdateQuery>;
export type GetCurrentMenuItemForUpdateLazyQueryHookResult = ReturnType<typeof useGetCurrentMenuItemForUpdateLazyQuery>;
export type GetCurrentMenuItemForUpdateSuspenseQueryHookResult = ReturnType<typeof useGetCurrentMenuItemForUpdateSuspenseQuery>;
export type GetCurrentMenuItemForUpdateQueryResult = Apollo.QueryResult<GetCurrentMenuItemForUpdateQuery, GetCurrentMenuItemForUpdateQueryVariables>;
export const GetMenuCategoriesForUpdateMenuItemsDocument = gql`
    query GetMenuCategoriesForUpdateMenuItems($companyId: Int!, $itemsPerPage: Int, $isDeleted: Boolean, $locale: String) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      id
      meMenuCategoriesPaginated(
        itemsPerPage: $itemsPerPage
        isDeleted: $isDeleted
        locale: $locale
      ) {
        categories {
          id
          name(locale: $locale)
          nameOrigin
          comment(locale: $locale)
          descriptionOrigin
          parentCategory {
            id
            name(locale: $locale)
            nameOrigin
            comment(locale: $locale)
            descriptionOrigin
            deleted
          }
          childCategories {
            id
            name(locale: $locale)
            nameOrigin
            comment(locale: $locale)
            descriptionOrigin
            deleted
            favicon {
              id
              path
              isDefault
            }
            parentCategory {
              id
              name(locale: $locale)
              nameOrigin
              deleted
              comment(locale: $locale)
              descriptionOrigin
              favicon {
                id
                isDefault
                path
              }
            }
          }
          company {
            id
          }
          deleted
          favicon {
            id
            path
            isDefault
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMenuCategoriesForUpdateMenuItemsQuery__
 *
 * To run a query within a React component, call `useGetMenuCategoriesForUpdateMenuItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuCategoriesForUpdateMenuItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuCategoriesForUpdateMenuItemsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      isDeleted: // value for 'isDeleted'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetMenuCategoriesForUpdateMenuItemsQuery(baseOptions: Apollo.QueryHookOptions<GetMenuCategoriesForUpdateMenuItemsQuery, GetMenuCategoriesForUpdateMenuItemsQueryVariables> & ({ variables: GetMenuCategoriesForUpdateMenuItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuCategoriesForUpdateMenuItemsQuery, GetMenuCategoriesForUpdateMenuItemsQueryVariables>(GetMenuCategoriesForUpdateMenuItemsDocument, options);
      }
export function useGetMenuCategoriesForUpdateMenuItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuCategoriesForUpdateMenuItemsQuery, GetMenuCategoriesForUpdateMenuItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuCategoriesForUpdateMenuItemsQuery, GetMenuCategoriesForUpdateMenuItemsQueryVariables>(GetMenuCategoriesForUpdateMenuItemsDocument, options);
        }
export function useGetMenuCategoriesForUpdateMenuItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuCategoriesForUpdateMenuItemsQuery, GetMenuCategoriesForUpdateMenuItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuCategoriesForUpdateMenuItemsQuery, GetMenuCategoriesForUpdateMenuItemsQueryVariables>(GetMenuCategoriesForUpdateMenuItemsDocument, options);
        }
export type GetMenuCategoriesForUpdateMenuItemsQueryHookResult = ReturnType<typeof useGetMenuCategoriesForUpdateMenuItemsQuery>;
export type GetMenuCategoriesForUpdateMenuItemsLazyQueryHookResult = ReturnType<typeof useGetMenuCategoriesForUpdateMenuItemsLazyQuery>;
export type GetMenuCategoriesForUpdateMenuItemsSuspenseQueryHookResult = ReturnType<typeof useGetMenuCategoriesForUpdateMenuItemsSuspenseQuery>;
export type GetMenuCategoriesForUpdateMenuItemsQueryResult = Apollo.QueryResult<GetMenuCategoriesForUpdateMenuItemsQuery, GetMenuCategoriesForUpdateMenuItemsQueryVariables>;
export const GetUnitsForUpdateMenuItemDocument = gql`
    query GetUnitsForUpdateMenuItem {
  relations {
    units {
      id
      name
    }
  }
}
    `;

/**
 * __useGetUnitsForUpdateMenuItemQuery__
 *
 * To run a query within a React component, call `useGetUnitsForUpdateMenuItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitsForUpdateMenuItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitsForUpdateMenuItemQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnitsForUpdateMenuItemQuery(baseOptions?: Apollo.QueryHookOptions<GetUnitsForUpdateMenuItemQuery, GetUnitsForUpdateMenuItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitsForUpdateMenuItemQuery, GetUnitsForUpdateMenuItemQueryVariables>(GetUnitsForUpdateMenuItemDocument, options);
      }
export function useGetUnitsForUpdateMenuItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitsForUpdateMenuItemQuery, GetUnitsForUpdateMenuItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitsForUpdateMenuItemQuery, GetUnitsForUpdateMenuItemQueryVariables>(GetUnitsForUpdateMenuItemDocument, options);
        }
export function useGetUnitsForUpdateMenuItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnitsForUpdateMenuItemQuery, GetUnitsForUpdateMenuItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnitsForUpdateMenuItemQuery, GetUnitsForUpdateMenuItemQueryVariables>(GetUnitsForUpdateMenuItemDocument, options);
        }
export type GetUnitsForUpdateMenuItemQueryHookResult = ReturnType<typeof useGetUnitsForUpdateMenuItemQuery>;
export type GetUnitsForUpdateMenuItemLazyQueryHookResult = ReturnType<typeof useGetUnitsForUpdateMenuItemLazyQuery>;
export type GetUnitsForUpdateMenuItemSuspenseQueryHookResult = ReturnType<typeof useGetUnitsForUpdateMenuItemSuspenseQuery>;
export type GetUnitsForUpdateMenuItemQueryResult = Apollo.QueryResult<GetUnitsForUpdateMenuItemQuery, GetUnitsForUpdateMenuItemQueryVariables>;
export const GetMenuAllergensForUpdateMenuItemDocument = gql`
    query GetMenuAllergensForUpdateMenuItem {
  menuAllergens {
    id
    name
    slug
  }
}
    `;

/**
 * __useGetMenuAllergensForUpdateMenuItemQuery__
 *
 * To run a query within a React component, call `useGetMenuAllergensForUpdateMenuItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuAllergensForUpdateMenuItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuAllergensForUpdateMenuItemQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMenuAllergensForUpdateMenuItemQuery(baseOptions?: Apollo.QueryHookOptions<GetMenuAllergensForUpdateMenuItemQuery, GetMenuAllergensForUpdateMenuItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuAllergensForUpdateMenuItemQuery, GetMenuAllergensForUpdateMenuItemQueryVariables>(GetMenuAllergensForUpdateMenuItemDocument, options);
      }
export function useGetMenuAllergensForUpdateMenuItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuAllergensForUpdateMenuItemQuery, GetMenuAllergensForUpdateMenuItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuAllergensForUpdateMenuItemQuery, GetMenuAllergensForUpdateMenuItemQueryVariables>(GetMenuAllergensForUpdateMenuItemDocument, options);
        }
export function useGetMenuAllergensForUpdateMenuItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuAllergensForUpdateMenuItemQuery, GetMenuAllergensForUpdateMenuItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuAllergensForUpdateMenuItemQuery, GetMenuAllergensForUpdateMenuItemQueryVariables>(GetMenuAllergensForUpdateMenuItemDocument, options);
        }
export type GetMenuAllergensForUpdateMenuItemQueryHookResult = ReturnType<typeof useGetMenuAllergensForUpdateMenuItemQuery>;
export type GetMenuAllergensForUpdateMenuItemLazyQueryHookResult = ReturnType<typeof useGetMenuAllergensForUpdateMenuItemLazyQuery>;
export type GetMenuAllergensForUpdateMenuItemSuspenseQueryHookResult = ReturnType<typeof useGetMenuAllergensForUpdateMenuItemSuspenseQuery>;
export type GetMenuAllergensForUpdateMenuItemQueryResult = Apollo.QueryResult<GetMenuAllergensForUpdateMenuItemQuery, GetMenuAllergensForUpdateMenuItemQueryVariables>;
export const GetMenuTypesForUpdateMenuItemDocument = gql`
    query GetMenuTypesForUpdateMenuItem {
  menuTypes {
    id
    name
    slug
  }
}
    `;

/**
 * __useGetMenuTypesForUpdateMenuItemQuery__
 *
 * To run a query within a React component, call `useGetMenuTypesForUpdateMenuItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuTypesForUpdateMenuItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuTypesForUpdateMenuItemQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMenuTypesForUpdateMenuItemQuery(baseOptions?: Apollo.QueryHookOptions<GetMenuTypesForUpdateMenuItemQuery, GetMenuTypesForUpdateMenuItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuTypesForUpdateMenuItemQuery, GetMenuTypesForUpdateMenuItemQueryVariables>(GetMenuTypesForUpdateMenuItemDocument, options);
      }
export function useGetMenuTypesForUpdateMenuItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuTypesForUpdateMenuItemQuery, GetMenuTypesForUpdateMenuItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuTypesForUpdateMenuItemQuery, GetMenuTypesForUpdateMenuItemQueryVariables>(GetMenuTypesForUpdateMenuItemDocument, options);
        }
export function useGetMenuTypesForUpdateMenuItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuTypesForUpdateMenuItemQuery, GetMenuTypesForUpdateMenuItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuTypesForUpdateMenuItemQuery, GetMenuTypesForUpdateMenuItemQueryVariables>(GetMenuTypesForUpdateMenuItemDocument, options);
        }
export type GetMenuTypesForUpdateMenuItemQueryHookResult = ReturnType<typeof useGetMenuTypesForUpdateMenuItemQuery>;
export type GetMenuTypesForUpdateMenuItemLazyQueryHookResult = ReturnType<typeof useGetMenuTypesForUpdateMenuItemLazyQuery>;
export type GetMenuTypesForUpdateMenuItemSuspenseQueryHookResult = ReturnType<typeof useGetMenuTypesForUpdateMenuItemSuspenseQuery>;
export type GetMenuTypesForUpdateMenuItemQueryResult = Apollo.QueryResult<GetMenuTypesForUpdateMenuItemQuery, GetMenuTypesForUpdateMenuItemQueryVariables>;
export const GetMenuMarkersForUpdateMenuItemDocument = gql`
    query GetMenuMarkersForUpdateMenuItem {
  menuMarkers {
    id
    name
    slug
  }
}
    `;

/**
 * __useGetMenuMarkersForUpdateMenuItemQuery__
 *
 * To run a query within a React component, call `useGetMenuMarkersForUpdateMenuItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuMarkersForUpdateMenuItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuMarkersForUpdateMenuItemQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMenuMarkersForUpdateMenuItemQuery(baseOptions?: Apollo.QueryHookOptions<GetMenuMarkersForUpdateMenuItemQuery, GetMenuMarkersForUpdateMenuItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuMarkersForUpdateMenuItemQuery, GetMenuMarkersForUpdateMenuItemQueryVariables>(GetMenuMarkersForUpdateMenuItemDocument, options);
      }
export function useGetMenuMarkersForUpdateMenuItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuMarkersForUpdateMenuItemQuery, GetMenuMarkersForUpdateMenuItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuMarkersForUpdateMenuItemQuery, GetMenuMarkersForUpdateMenuItemQueryVariables>(GetMenuMarkersForUpdateMenuItemDocument, options);
        }
export function useGetMenuMarkersForUpdateMenuItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuMarkersForUpdateMenuItemQuery, GetMenuMarkersForUpdateMenuItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuMarkersForUpdateMenuItemQuery, GetMenuMarkersForUpdateMenuItemQueryVariables>(GetMenuMarkersForUpdateMenuItemDocument, options);
        }
export type GetMenuMarkersForUpdateMenuItemQueryHookResult = ReturnType<typeof useGetMenuMarkersForUpdateMenuItemQuery>;
export type GetMenuMarkersForUpdateMenuItemLazyQueryHookResult = ReturnType<typeof useGetMenuMarkersForUpdateMenuItemLazyQuery>;
export type GetMenuMarkersForUpdateMenuItemSuspenseQueryHookResult = ReturnType<typeof useGetMenuMarkersForUpdateMenuItemSuspenseQuery>;
export type GetMenuMarkersForUpdateMenuItemQueryResult = Apollo.QueryResult<GetMenuMarkersForUpdateMenuItemQuery, GetMenuMarkersForUpdateMenuItemQueryVariables>;
export const GetLanguageVersionsForUpdateMenuItemDocument = gql`
    query GetLanguageVersionsForUpdateMenuItem($companyId: Int!) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      languages {
        id
        name
      }
      primaryLanguage {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetLanguageVersionsForUpdateMenuItemQuery__
 *
 * To run a query within a React component, call `useGetLanguageVersionsForUpdateMenuItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLanguageVersionsForUpdateMenuItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLanguageVersionsForUpdateMenuItemQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetLanguageVersionsForUpdateMenuItemQuery(baseOptions: Apollo.QueryHookOptions<GetLanguageVersionsForUpdateMenuItemQuery, GetLanguageVersionsForUpdateMenuItemQueryVariables> & ({ variables: GetLanguageVersionsForUpdateMenuItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLanguageVersionsForUpdateMenuItemQuery, GetLanguageVersionsForUpdateMenuItemQueryVariables>(GetLanguageVersionsForUpdateMenuItemDocument, options);
      }
export function useGetLanguageVersionsForUpdateMenuItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLanguageVersionsForUpdateMenuItemQuery, GetLanguageVersionsForUpdateMenuItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLanguageVersionsForUpdateMenuItemQuery, GetLanguageVersionsForUpdateMenuItemQueryVariables>(GetLanguageVersionsForUpdateMenuItemDocument, options);
        }
export function useGetLanguageVersionsForUpdateMenuItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLanguageVersionsForUpdateMenuItemQuery, GetLanguageVersionsForUpdateMenuItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLanguageVersionsForUpdateMenuItemQuery, GetLanguageVersionsForUpdateMenuItemQueryVariables>(GetLanguageVersionsForUpdateMenuItemDocument, options);
        }
export type GetLanguageVersionsForUpdateMenuItemQueryHookResult = ReturnType<typeof useGetLanguageVersionsForUpdateMenuItemQuery>;
export type GetLanguageVersionsForUpdateMenuItemLazyQueryHookResult = ReturnType<typeof useGetLanguageVersionsForUpdateMenuItemLazyQuery>;
export type GetLanguageVersionsForUpdateMenuItemSuspenseQueryHookResult = ReturnType<typeof useGetLanguageVersionsForUpdateMenuItemSuspenseQuery>;
export type GetLanguageVersionsForUpdateMenuItemQueryResult = Apollo.QueryResult<GetLanguageVersionsForUpdateMenuItemQuery, GetLanguageVersionsForUpdateMenuItemQueryVariables>;
export const GetDishSupplementsListForUpdateMenuItemDocument = gql`
    query GetDishSupplementsListForUpdateMenuItem($companyId: Int!, $isDeleted: Boolean, $search: String, $onlyParent: Boolean, $locale: String) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      currency {
        currencySign
      }
      menuSupplementsList(
        isDeleted: $isDeleted
        search: $search
        onlyParent: $onlyParent
      ) {
        id
        groupName(locale: $locale)
        groupNameOrigin
        options {
          id
          name(locale: $locale)
          nameOrigin
          price
          deleted
        }
      }
    }
  }
}
    `;

/**
 * __useGetDishSupplementsListForUpdateMenuItemQuery__
 *
 * To run a query within a React component, call `useGetDishSupplementsListForUpdateMenuItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDishSupplementsListForUpdateMenuItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDishSupplementsListForUpdateMenuItemQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      isDeleted: // value for 'isDeleted'
 *      search: // value for 'search'
 *      onlyParent: // value for 'onlyParent'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetDishSupplementsListForUpdateMenuItemQuery(baseOptions: Apollo.QueryHookOptions<GetDishSupplementsListForUpdateMenuItemQuery, GetDishSupplementsListForUpdateMenuItemQueryVariables> & ({ variables: GetDishSupplementsListForUpdateMenuItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDishSupplementsListForUpdateMenuItemQuery, GetDishSupplementsListForUpdateMenuItemQueryVariables>(GetDishSupplementsListForUpdateMenuItemDocument, options);
      }
export function useGetDishSupplementsListForUpdateMenuItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDishSupplementsListForUpdateMenuItemQuery, GetDishSupplementsListForUpdateMenuItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDishSupplementsListForUpdateMenuItemQuery, GetDishSupplementsListForUpdateMenuItemQueryVariables>(GetDishSupplementsListForUpdateMenuItemDocument, options);
        }
export function useGetDishSupplementsListForUpdateMenuItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDishSupplementsListForUpdateMenuItemQuery, GetDishSupplementsListForUpdateMenuItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDishSupplementsListForUpdateMenuItemQuery, GetDishSupplementsListForUpdateMenuItemQueryVariables>(GetDishSupplementsListForUpdateMenuItemDocument, options);
        }
export type GetDishSupplementsListForUpdateMenuItemQueryHookResult = ReturnType<typeof useGetDishSupplementsListForUpdateMenuItemQuery>;
export type GetDishSupplementsListForUpdateMenuItemLazyQueryHookResult = ReturnType<typeof useGetDishSupplementsListForUpdateMenuItemLazyQuery>;
export type GetDishSupplementsListForUpdateMenuItemSuspenseQueryHookResult = ReturnType<typeof useGetDishSupplementsListForUpdateMenuItemSuspenseQuery>;
export type GetDishSupplementsListForUpdateMenuItemQueryResult = Apollo.QueryResult<GetDishSupplementsListForUpdateMenuItemQuery, GetDishSupplementsListForUpdateMenuItemQueryVariables>;
export const GetDishSupplementsNameAndIdDocument = gql`
    query GetDishSupplementsNameAndId($companyId: Int!, $isDeleted: Boolean, $onlyParent: Boolean, $locale: String) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      menuSupplementsList(isDeleted: $isDeleted, onlyParent: $onlyParent) {
        id
        groupName(locale: $locale)
        groupNameOrigin
      }
    }
  }
}
    `;

/**
 * __useGetDishSupplementsNameAndIdQuery__
 *
 * To run a query within a React component, call `useGetDishSupplementsNameAndIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDishSupplementsNameAndIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDishSupplementsNameAndIdQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      isDeleted: // value for 'isDeleted'
 *      onlyParent: // value for 'onlyParent'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetDishSupplementsNameAndIdQuery(baseOptions: Apollo.QueryHookOptions<GetDishSupplementsNameAndIdQuery, GetDishSupplementsNameAndIdQueryVariables> & ({ variables: GetDishSupplementsNameAndIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDishSupplementsNameAndIdQuery, GetDishSupplementsNameAndIdQueryVariables>(GetDishSupplementsNameAndIdDocument, options);
      }
export function useGetDishSupplementsNameAndIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDishSupplementsNameAndIdQuery, GetDishSupplementsNameAndIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDishSupplementsNameAndIdQuery, GetDishSupplementsNameAndIdQueryVariables>(GetDishSupplementsNameAndIdDocument, options);
        }
export function useGetDishSupplementsNameAndIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDishSupplementsNameAndIdQuery, GetDishSupplementsNameAndIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDishSupplementsNameAndIdQuery, GetDishSupplementsNameAndIdQueryVariables>(GetDishSupplementsNameAndIdDocument, options);
        }
export type GetDishSupplementsNameAndIdQueryHookResult = ReturnType<typeof useGetDishSupplementsNameAndIdQuery>;
export type GetDishSupplementsNameAndIdLazyQueryHookResult = ReturnType<typeof useGetDishSupplementsNameAndIdLazyQuery>;
export type GetDishSupplementsNameAndIdSuspenseQueryHookResult = ReturnType<typeof useGetDishSupplementsNameAndIdSuspenseQuery>;
export type GetDishSupplementsNameAndIdQueryResult = Apollo.QueryResult<GetDishSupplementsNameAndIdQuery, GetDishSupplementsNameAndIdQueryVariables>;
export const GetDishSupplementByIdDocument = gql`
    query GetDishSupplementById($companyId: Int!, $supplementId: Int, $locale: String) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      menuSupplementsList(id: $supplementId) {
        id
        groupName(locale: $locale)
        groupNameOrigin
        items {
          id
          name(locale: $locale)
          nameOrigin
        }
        options {
          id
          name(locale: $locale)
          nameOrigin
          price
          deleted
        }
        isRequireOnOrder
        maxCountOnOrder
      }
    }
  }
}
    `;

/**
 * __useGetDishSupplementByIdQuery__
 *
 * To run a query within a React component, call `useGetDishSupplementByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDishSupplementByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDishSupplementByIdQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      supplementId: // value for 'supplementId'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetDishSupplementByIdQuery(baseOptions: Apollo.QueryHookOptions<GetDishSupplementByIdQuery, GetDishSupplementByIdQueryVariables> & ({ variables: GetDishSupplementByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDishSupplementByIdQuery, GetDishSupplementByIdQueryVariables>(GetDishSupplementByIdDocument, options);
      }
export function useGetDishSupplementByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDishSupplementByIdQuery, GetDishSupplementByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDishSupplementByIdQuery, GetDishSupplementByIdQueryVariables>(GetDishSupplementByIdDocument, options);
        }
export function useGetDishSupplementByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDishSupplementByIdQuery, GetDishSupplementByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDishSupplementByIdQuery, GetDishSupplementByIdQueryVariables>(GetDishSupplementByIdDocument, options);
        }
export type GetDishSupplementByIdQueryHookResult = ReturnType<typeof useGetDishSupplementByIdQuery>;
export type GetDishSupplementByIdLazyQueryHookResult = ReturnType<typeof useGetDishSupplementByIdLazyQuery>;
export type GetDishSupplementByIdSuspenseQueryHookResult = ReturnType<typeof useGetDishSupplementByIdSuspenseQuery>;
export type GetDishSupplementByIdQueryResult = Apollo.QueryResult<GetDishSupplementByIdQuery, GetDishSupplementByIdQueryVariables>;
export const CheckMenuItemAvailabilityForMenuTypeDocument = gql`
    query CheckMenuItemAvailabilityForMenuType($companyId: Int!, $branchId: Int, $dishId: Int) {
  user(companyId: $companyId, branchId: $branchId) {
    id
    company(id: $companyId) {
      id
      menuItemsList(id: $dishId) {
        id
        availableDeliveryMenus {
          id
        }
        availableDineInMenus {
          id
        }
        availablePickupMenus {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useCheckMenuItemAvailabilityForMenuTypeQuery__
 *
 * To run a query within a React component, call `useCheckMenuItemAvailabilityForMenuTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckMenuItemAvailabilityForMenuTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckMenuItemAvailabilityForMenuTypeQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *      dishId: // value for 'dishId'
 *   },
 * });
 */
export function useCheckMenuItemAvailabilityForMenuTypeQuery(baseOptions: Apollo.QueryHookOptions<CheckMenuItemAvailabilityForMenuTypeQuery, CheckMenuItemAvailabilityForMenuTypeQueryVariables> & ({ variables: CheckMenuItemAvailabilityForMenuTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckMenuItemAvailabilityForMenuTypeQuery, CheckMenuItemAvailabilityForMenuTypeQueryVariables>(CheckMenuItemAvailabilityForMenuTypeDocument, options);
      }
export function useCheckMenuItemAvailabilityForMenuTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckMenuItemAvailabilityForMenuTypeQuery, CheckMenuItemAvailabilityForMenuTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckMenuItemAvailabilityForMenuTypeQuery, CheckMenuItemAvailabilityForMenuTypeQueryVariables>(CheckMenuItemAvailabilityForMenuTypeDocument, options);
        }
export function useCheckMenuItemAvailabilityForMenuTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckMenuItemAvailabilityForMenuTypeQuery, CheckMenuItemAvailabilityForMenuTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckMenuItemAvailabilityForMenuTypeQuery, CheckMenuItemAvailabilityForMenuTypeQueryVariables>(CheckMenuItemAvailabilityForMenuTypeDocument, options);
        }
export type CheckMenuItemAvailabilityForMenuTypeQueryHookResult = ReturnType<typeof useCheckMenuItemAvailabilityForMenuTypeQuery>;
export type CheckMenuItemAvailabilityForMenuTypeLazyQueryHookResult = ReturnType<typeof useCheckMenuItemAvailabilityForMenuTypeLazyQuery>;
export type CheckMenuItemAvailabilityForMenuTypeSuspenseQueryHookResult = ReturnType<typeof useCheckMenuItemAvailabilityForMenuTypeSuspenseQuery>;
export type CheckMenuItemAvailabilityForMenuTypeQueryResult = Apollo.QueryResult<CheckMenuItemAvailabilityForMenuTypeQuery, CheckMenuItemAvailabilityForMenuTypeQueryVariables>;
export const UpdateMenuItemDocument = gql`
    mutation UpdateMenuItem($menuItemId: Int!, $companyId: Int!, $input: MenuItemInput!, $locale: String, $branchId: Int!) {
  updateMenuItem(
    id: $menuItemId
    companyId: $companyId
    input: $input
    locale: $locale
    branchId: $branchId
  ) {
    id
  }
}
    `;
export type UpdateMenuItemMutationFn = Apollo.MutationFunction<UpdateMenuItemMutation, UpdateMenuItemMutationVariables>;

/**
 * __useUpdateMenuItemMutation__
 *
 * To run a mutation, you first call `useUpdateMenuItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMenuItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMenuItemMutation, { data, loading, error }] = useUpdateMenuItemMutation({
 *   variables: {
 *      menuItemId: // value for 'menuItemId'
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *      locale: // value for 'locale'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useUpdateMenuItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMenuItemMutation, UpdateMenuItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMenuItemMutation, UpdateMenuItemMutationVariables>(UpdateMenuItemDocument, options);
      }
export type UpdateMenuItemMutationHookResult = ReturnType<typeof useUpdateMenuItemMutation>;
export type UpdateMenuItemMutationResult = Apollo.MutationResult<UpdateMenuItemMutation>;
export type UpdateMenuItemMutationOptions = Apollo.BaseMutationOptions<UpdateMenuItemMutation, UpdateMenuItemMutationVariables>;
export const CreateMenuItemDocument = gql`
    mutation CreateMenuItem($companyId: Int!, $input: MenuItemInput!, $branchId: Int!, $locale: String) {
  createMenuItem(
    companyId: $companyId
    input: $input
    branchId: $branchId
    locale: $locale
  ) {
    id
  }
}
    `;
export type CreateMenuItemMutationFn = Apollo.MutationFunction<CreateMenuItemMutation, CreateMenuItemMutationVariables>;

/**
 * __useCreateMenuItemMutation__
 *
 * To run a mutation, you first call `useCreateMenuItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMenuItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMenuItemMutation, { data, loading, error }] = useCreateMenuItemMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *      branchId: // value for 'branchId'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useCreateMenuItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateMenuItemMutation, CreateMenuItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMenuItemMutation, CreateMenuItemMutationVariables>(CreateMenuItemDocument, options);
      }
export type CreateMenuItemMutationHookResult = ReturnType<typeof useCreateMenuItemMutation>;
export type CreateMenuItemMutationResult = Apollo.MutationResult<CreateMenuItemMutation>;
export type CreateMenuItemMutationOptions = Apollo.BaseMutationOptions<CreateMenuItemMutation, CreateMenuItemMutationVariables>;
export const CreateMenuCategoryForUpdateMenuItemDocument = gql`
    mutation CreateMenuCategoryForUpdateMenuItem($companyId: Int!, $input: MenuCategoryInput!, $branchId: Int!, $locale: String) {
  createMenuCategory(
    companyId: $companyId
    input: $input
    branchId: $branchId
    locale: $locale
  ) {
    id
  }
}
    `;
export type CreateMenuCategoryForUpdateMenuItemMutationFn = Apollo.MutationFunction<CreateMenuCategoryForUpdateMenuItemMutation, CreateMenuCategoryForUpdateMenuItemMutationVariables>;

/**
 * __useCreateMenuCategoryForUpdateMenuItemMutation__
 *
 * To run a mutation, you first call `useCreateMenuCategoryForUpdateMenuItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMenuCategoryForUpdateMenuItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMenuCategoryForUpdateMenuItemMutation, { data, loading, error }] = useCreateMenuCategoryForUpdateMenuItemMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *      branchId: // value for 'branchId'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useCreateMenuCategoryForUpdateMenuItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateMenuCategoryForUpdateMenuItemMutation, CreateMenuCategoryForUpdateMenuItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMenuCategoryForUpdateMenuItemMutation, CreateMenuCategoryForUpdateMenuItemMutationVariables>(CreateMenuCategoryForUpdateMenuItemDocument, options);
      }
export type CreateMenuCategoryForUpdateMenuItemMutationHookResult = ReturnType<typeof useCreateMenuCategoryForUpdateMenuItemMutation>;
export type CreateMenuCategoryForUpdateMenuItemMutationResult = Apollo.MutationResult<CreateMenuCategoryForUpdateMenuItemMutation>;
export type CreateMenuCategoryForUpdateMenuItemMutationOptions = Apollo.BaseMutationOptions<CreateMenuCategoryForUpdateMenuItemMutation, CreateMenuCategoryForUpdateMenuItemMutationVariables>;
export type GetCurrentMenuItemForUpdateQueryVariables = Types.Exact<{
  dishId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  companyId: Types.Scalars['Int']['input'];
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
  isDeletedSupplements?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetCurrentMenuItemForUpdateQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, menuItems?: { __typename?: 'MenuItemPaginated', items?: Array<{ __typename?: 'MenuItemProxy', id: number, name?: string | null, nameOrigin?: string | null, deleted: boolean, favicon?: string | null, description?: string | null, descriptionOrigin?: string | null, composition?: string | null, compositionOrigin?: string | null, cookingTime?: string | null, isLongCookingTime: boolean, types?: Array<{ __typename?: 'MenuTypeProxy', id: number, name: string, slug: string }> | null, categories?: Array<{ __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, comment?: string | null, descriptionOrigin?: string | null, deleted: boolean, favicon?: { __typename?: 'MenuCategoryIconProxy', id: number, isDefault: boolean, path?: string | null } | null, parentCategory?: { __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, comment?: string | null, descriptionOrigin?: string | null, deleted: boolean, favicon?: { __typename?: 'MenuCategoryIconProxy', id: number, isDefault: boolean, path?: string | null } | null, childCategories?: Array<{ __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, comment?: string | null, descriptionOrigin?: string | null, deleted: boolean, favicon?: { __typename?: 'MenuCategoryIconProxy', id: number, isDefault: boolean, path?: string | null } | null }> | null } | null, company: { __typename?: 'CompanyProxy', id: number } }> | null, unit: { __typename?: 'UnitProxy', id: number, name: string }, portions?: Array<{ __typename?: 'MenuItemPortionProxy', id: number, name?: string | null, nameOrigin?: string | null, volume: number, price: number }> | null, markers?: Array<{ __typename?: 'MenuMarkerProxy', id: number, name: string, slug: string }> | null, allergens?: Array<{ __typename?: 'MenuAllergenProxy', id: number, name: string, slug: string }> | null, supplements?: Array<{ __typename?: 'MenuSupplementProxy', id: number, groupName?: string | null, groupNameOrigin?: string | null }> | null }> | null } | null } | null } | null };

export type GetMenuCategoriesForUpdateMenuItemsQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  isDeleted?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetMenuCategoriesForUpdateMenuItemsQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, meMenuCategoriesPaginated?: { __typename?: 'MenuCategoryPaginated', categories?: Array<{ __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, comment?: string | null, descriptionOrigin?: string | null, deleted: boolean, parentCategory?: { __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, comment?: string | null, descriptionOrigin?: string | null, deleted: boolean } | null, childCategories?: Array<{ __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, comment?: string | null, descriptionOrigin?: string | null, deleted: boolean, favicon?: { __typename?: 'MenuCategoryIconProxy', id: number, path?: string | null, isDefault: boolean } | null, parentCategory?: { __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, deleted: boolean, comment?: string | null, descriptionOrigin?: string | null, favicon?: { __typename?: 'MenuCategoryIconProxy', id: number, isDefault: boolean, path?: string | null } | null } | null }> | null, company: { __typename?: 'CompanyProxy', id: number }, favicon?: { __typename?: 'MenuCategoryIconProxy', id: number, path?: string | null, isDefault: boolean } | null }> | null } | null } | null } | null };

export type GetUnitsForUpdateMenuItemQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUnitsForUpdateMenuItemQuery = { __typename?: 'Query', relations: { __typename?: 'RelationProxy', units?: Array<{ __typename?: 'UnitProxy', id: number, name: string }> | null } };

export type GetMenuAllergensForUpdateMenuItemQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMenuAllergensForUpdateMenuItemQuery = { __typename?: 'Query', menuAllergens: Array<{ __typename?: 'MenuAllergenProxy', id: number, name: string, slug: string }> };

export type GetMenuTypesForUpdateMenuItemQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMenuTypesForUpdateMenuItemQuery = { __typename?: 'Query', menuTypes: Array<{ __typename?: 'MenuTypeProxy', id: number, name: string, slug: string }> };

export type GetMenuMarkersForUpdateMenuItemQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMenuMarkersForUpdateMenuItemQuery = { __typename?: 'Query', menuMarkers: Array<{ __typename?: 'MenuMarkerProxy', id: number, name: string, slug: string }> };

export type GetLanguageVersionsForUpdateMenuItemQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetLanguageVersionsForUpdateMenuItemQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', languages?: Array<{ __typename?: 'LanguageProxy', id: number, name: string }> | null, primaryLanguage?: { __typename?: 'LanguageProxy', id: number, name: string } | null } | null } | null };

export type GetDishSupplementsListForUpdateMenuItemQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  isDeleted?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  onlyParent?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetDishSupplementsListForUpdateMenuItemQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', currency?: { __typename?: 'CurrencyProxy', currencySign?: string | null } | null, menuSupplementsList?: Array<{ __typename?: 'MenuSupplementProxy', id: number, groupName?: string | null, groupNameOrigin?: string | null, options?: Array<{ __typename?: 'MenuSupplementProxy', id: number, name?: string | null, nameOrigin?: string | null, price?: number | null, deleted: boolean }> | null }> | null } | null } | null };

export type GetDishSupplementsNameAndIdQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  isDeleted?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  onlyParent?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetDishSupplementsNameAndIdQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', menuSupplementsList?: Array<{ __typename?: 'MenuSupplementProxy', id: number, groupName?: string | null, groupNameOrigin?: string | null }> | null } | null } | null };

export type GetDishSupplementByIdQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  supplementId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetDishSupplementByIdQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', menuSupplementsList?: Array<{ __typename?: 'MenuSupplementProxy', id: number, groupName?: string | null, groupNameOrigin?: string | null, isRequireOnOrder?: boolean | null, maxCountOnOrder?: number | null, items?: Array<{ __typename?: 'MenuItemProxy', id: number, name?: string | null, nameOrigin?: string | null }> | null, options?: Array<{ __typename?: 'MenuSupplementProxy', id: number, name?: string | null, nameOrigin?: string | null, price?: number | null, deleted: boolean }> | null }> | null } | null } | null };

export type CheckMenuItemAvailabilityForMenuTypeQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  dishId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type CheckMenuItemAvailabilityForMenuTypeQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, menuItemsList?: Array<{ __typename?: 'MenuItemProxy', id: number, availableDeliveryMenus?: Array<{ __typename?: 'MenuProxy', id: number }> | null, availableDineInMenus?: Array<{ __typename?: 'MenuProxy', id: number }> | null, availablePickupMenus?: Array<{ __typename?: 'MenuProxy', id: number }> | null } | null> | null } | null } | null };

export type UpdateMenuItemMutationVariables = Types.Exact<{
  menuItemId: Types.Scalars['Int']['input'];
  companyId: Types.Scalars['Int']['input'];
  input: Types.MenuItemInput;
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
  branchId: Types.Scalars['Int']['input'];
}>;


export type UpdateMenuItemMutation = { __typename?: 'Mutation', updateMenuItem: { __typename?: 'MenuItemProxy', id: number } };

export type CreateMenuItemMutationVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  input: Types.MenuItemInput;
  branchId: Types.Scalars['Int']['input'];
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type CreateMenuItemMutation = { __typename?: 'Mutation', createMenuItem: { __typename?: 'MenuItemProxy', id: number } };

export type CreateMenuCategoryForUpdateMenuItemMutationVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  input: Types.MenuCategoryInput;
  branchId: Types.Scalars['Int']['input'];
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type CreateMenuCategoryForUpdateMenuItemMutation = { __typename?: 'Mutation', createMenuCategory: { __typename?: 'MenuCategoryProxy', id: number } };
